import React from "react";

const FooterLinks = ({ text }) => {
	return (
		<>
			<button className="text-gray-100 text-base pb-3 hover:text-cyan">{text}</button>
		</>
	);
};

export default FooterLinks;
